import React from 'react';
import heroBg from '../assets/images/hero-bg.jpg';

const Hero: React.FC = () => {
  return (
    <section className="relative h-screen w-full">
      {/* Background image div */}
      <div 
        className="absolute inset-0 z-0"
        style={{ 
          backgroundImage: `url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />
      
      {/* Dark overlay with subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy/60 via-navy/40 to-navy/60 z-1"></div>
      
      {/* Content container */}
      <div className="relative z-10 flex items-center justify-center h-full">
        <div className="text-left px-8 max-w-4xl mx-auto">
          <div className="space-y-8">
            <div className="border-l-4 border-teal pl-8">
              <p className="text-2xl md:text-3xl font-light text-white leading-relaxed tracking-wide">
                In an era of unprecedented energy transformation,
              </p>
            </div>
            
            <div className="pl-12">
              <p className="text-3xl md:text-4xl font-medium text-white leading-tight tracking-tight">
                Hatom operates where bold vision meets executable strategy
              </p>
            </div>
            
            <div className="pl-12">
              <p className="text-xl md:text-2xl font-light text-white/90 leading-relaxed tracking-wide">
                standing at the nexus of innovation and capital to engineer what others deem impossible. From solar-drenched plains to revolutionary green hydrogen production, we architect the invisible frameworks that turn ambition into reality, merging market foresight with precision financing to empower those rewriting how the world generates and consumes energy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;